/**
 * Add register icons to the template cache so they may be referenced
 */
export const REGISTER_IMAGES_CACHE_PREFIX = 'register/images/';
export default function cacheAccountIcons($templateCache) {
  'ngInject';

  // (Use the html loader to pull the SVG content directly into the template cache.)
  const requireImages = require.context('!html!./images', true, /\.svg$/);

  _.forEach(requireImages.keys(), img => {
    // Store icons in cache at app-switcher/icons/Box.svg
    // strip off leading ./
    let imgFileName = img.substr(2);
    $templateCache.put(REGISTER_IMAGES_CACHE_PREFIX + imgFileName, requireImages(img));
  });
}



// WEBPACK FOOTER //
// ./cache-images.run.js